// Videos carry their file in data-src so nothing is downloaded during page load.
// After the load event, only the videos that are actually visible get their source
// (hidden mobile/desktop variants are skipped) and start playing.
export const initLazyVideo = () => {
    const start = () => {
        document.querySelectorAll('video[data-src]').forEach((video) => {
            if (video.offsetParent === null) {
                return;
            }
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
            const playing = video.play();
            if (playing && playing.catch) {
                playing.catch(() => {});
            }
        });
    };

    if (document.readyState === 'complete') {
        start();
    } else {
        window.addEventListener('load', start, {once: true});
    }
};
